module.exports = __webpack_public_path__ + "static/media/icon_classBlue.e77f3841.svg";